import { useEffect } from 'react';
import { useSubflowTemplateActions } from './useSubflowTemplateActions';

export const useSubflowTemplateInit = () => {
  const { fetchSubflowTemplates } = useSubflowTemplateActions();

  useEffect(() => {
    fetchSubflowTemplates();
  }, [fetchSubflowTemplates]);
};
